/* Die eigene Terminauswahl.
 *
 * Der Server liefert nur die Tage, an denen etwas frei ist. Das
 * Monatsraster hier herum wird im Browser gebaut, damit man sieht,
 * wo man sich befindet, und nicht nur eine Liste von Resten.
 *
 * Gerechnet wird ausschliesslich mit Zeichenketten der Form
 * "2026-10-09" und Date.UTC. Sobald man ein Datum in der Zeitzone des
 * Geraets anlegt, verschiebt sich irgendwo auf der Welt ein Tag, und
 * dann zeigt der Kalender den falschen Wochentag an.
 */
(function () {
  'use strict';

  var TAGE_KURZ = ['Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So'];
  var MONATE = ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni',
    'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'];

  function teile(iso) {
    var p = iso.split('-');
    return { j: +p[0], m: +p[1], t: +p[2] };
  }

  /** Wochentag, 0 = Montag ... 6 = Sonntag. */
  function wochentag(j, m, t) {
    return (new Date(Date.UTC(j, m - 1, t)).getUTCDay() + 6) % 7;
  }

  function tageImMonat(j, m) {
    return new Date(Date.UTC(j, m, 0)).getUTCDate();
  }

  function iso(j, m, t) {
    return j + '-' + String(m).padStart(2, '0') + '-' + String(t).padStart(2, '0');
  }


  /* ---------- Meta: Termin gebucht ----------
   *
   * Meta soll lernen, wer einen Termin bucht, nicht nur wer die Seite
   * aufruft. Der Pixel von Shopify ist in einer Sandbox und nimmt keine
   * eigenen Ereignisse an, also laden wir den Pixel hier selbst, aber
   * nur, wenn der Besucher Marketing-Cookies erlaubt hat. Pandectes
   * meldet das als Bitmaske, gesetztes Bit 4 heisst abgelehnt. Ohne
   * Einwilligung wird nichts geladen und nichts gesendet.
   */
  /* Woher kam der Besucher? Kampagnenangaben aus dem Link, sonst aus der
   * Sitzung (layout/theme.liquid merkt sie beim Einstieg), sonst die
   * verweisende Seite. Geht mit der Buchung an den Kalender. */
  function herkunft() {
    try {
      var q = new URLSearchParams(location.search);
      if (q.get('utm_source') || q.get('fbclid')) {
        return { quelle: q.get('utm_source') || 'meta', kampagne: q.get('utm_campaign') || '', inhalt: q.get('utm_content') || '' };
      }
      var s = sessionStorage.getItem('fp-herkunft');
      if (s) return JSON.parse(s);
    } catch (e) {}
    var r = '';
    try { r = document.referrer ? new URL(document.referrer).hostname : ''; } catch (e) {}
    return { quelle: r && r.indexOf('formaprior') === -1 ? r : 'direkt', kampagne: '', inhalt: '' };
  }

  var PIXEL = '844065014783066';
  var einwilligung = null;

  window.addEventListener('PandectesEvent_OnConsent', function (e) {
    var p = e && e.detail ? e.detail.preferences : null;
    if (typeof p === 'number') einwilligung = p;
  });

  function marketingErlaubt() {
    var p = einwilligung;
    if (p === null) {
      try {
        var roh = (document.cookie.match(/(?:^|; )_pandectes_gdpr=([^;]+)/) || [])[1];
        var daten = roh ? JSON.parse(atob(decodeURIComponent(roh))) : null;
        if (daten && typeof daten.preferences === 'number') p = daten.preferences;
      } catch (e) { p = null; }
    }
    return typeof p === 'number' && (p & 4) === 0;
  }

  function metaTermin(daten) {
    if (!marketingErlaubt() || window.fpIntern) return;
    /* eslint-disable */
    if (!window.fbq) {
      !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;
      n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,
      document,'script','https://connect.facebook.net/en_US/fbevents.js');
    }
    /* eslint-enable */
    window.fbq('init', PIXEL);
    window.fbq('trackSingle', PIXEL, 'Schedule', { content_name: 'Beratung' },
      { eventID: 'termin-' + ((daten && daten.id) || Date.now()) });
  }

  function starte(wurzel) {
    if (wurzel.dataset.fpTmBereit === '1') return;
    wurzel.dataset.fpTmBereit = '1';

    var api = (wurzel.dataset.fpApi || '').replace(/\/+$/, '');
    if (!api) return;

    var text = {};
    try {
      text = JSON.parse(wurzel.dataset.fpText || '{}');
    } catch (e) {
      text = {};
    }

    // Die Monatsnamen kommen aus Liquid, weil der Shop zweisprachig ist.
    var monatsnamen = Array.isArray(text.monate) && text.monate.length === 12
      ? text.monate
      : MONATE;

    function $(wahl) { return wurzel.querySelector(wahl); }
    function zeige(el, ja) { if (el) el.hidden = !ja; }

    var elLaedt = $('.fp-tm__laedt');
    var elWaehlen = $('.fp-tm__waehlen');
    var elMonat = $('.fp-tm__monat');
    var elGitter = $('.fp-tm__gitter');
    var elRueck = $('.fp-tm__pfeil[data-rueck]');
    var elVor = $('.fp-tm__pfeil[data-vor]');
    var elZeitkopf = $('.fp-tm__zeitkopf');
    var elZeiten = $('.fp-tm__zeiten');
    var elS3 = $('.fp-tm__s3');
    var elFehler = $('.fp-tm__fehler');
    var elSenden = $('.fp-tm__senden');
    var elForm = $('.fp-tm__ablauf');
    var elFertig = $('.fp-tm__fertig');
    var elSchnell = $('.fp-tm__schnell');
    var elMehr = $('.fp-tm__mehr');

    var nachTag = {};      // "2026-10-09" -> Tagesobjekt vom Server
    var monate = [];       // ["2026-10", "2026-11"] in Reihenfolge
    var zeigt = 0;         // Index in monate
    var gewaehlt = null;   // gewaehltes Fenster
    var gewaehlterTag = null;

    function fehler(meldung) {
      if (!elFehler) return;
      elFehler.textContent = meldung;
      zeige(elFehler, true);
    }

    /* ---------- Fenster holen ---------- */

    fetch(api + '/slots', { headers: { accept: 'application/json' } })
      .then(function (r) {
        if (!r.ok) throw new Error(String(r.status));
        return r.json();
      })
      .then(function (daten) {
        if (!daten.tage || !daten.tage.length) {
          elLaedt.textContent = text.leer || '';
          return;
        }

        daten.tage.forEach(function (t) {
          nachTag[t.tag] = t;
          var m = t.tag.slice(0, 7);
          if (monate.indexOf(m) === -1) monate.push(m);
        });

        zeige(elLaedt, false);
        zeige(elWaehlen, true);
        zeichne();
        waehleTag(daten.tage[0].tag);
        schnellwahl(daten.tage);
      })
      .catch(function () {
        elLaedt.textContent = text.ausfall || '';
      });

    /* ---------- Monatsraster ---------- */

    function zeichne() {
      var p = teile(monate[zeigt] + '-01');
      elMonat.textContent = monatsnamen[p.m - 1] + ' ' + p.j;

      elRueck.disabled = zeigt === 0;
      elVor.disabled = zeigt >= monate.length - 1;

      elGitter.innerHTML = '';

      var vorlauf = wochentag(p.j, p.m, 1);
      for (var i = 0; i < vorlauf; i++) {
        var leer = document.createElement('span');
        leer.className = 'fp-tm__tag fp-tm__tag--leer';
        elGitter.appendChild(leer);
      }

      var anzahl = tageImMonat(p.j, p.m);
      for (var t = 1; t <= anzahl; t++) {
        var datum = iso(p.j, p.m, t);
        var frei = nachTag[datum];

        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'fp-tm__tag';
        b.textContent = String(t);

        if (frei) {
          b.setAttribute('data-frei', '1');
          b.setAttribute('aria-pressed', String(datum === gewaehlterTag));
          b.setAttribute('aria-label', frei.lesbar);
          b.dataset.tag = datum;
          b.addEventListener('click', function () { waehleTag(this.dataset.tag); });
        } else {
          b.disabled = true;
        }
        elGitter.appendChild(b);
      }
    }

    elRueck.addEventListener('click', function () {
      if (zeigt > 0) { zeigt--; zeichne(); }
    });
    elVor.addEventListener('click', function () {
      if (zeigt < monate.length - 1) { zeigt++; zeichne(); }
    });

    /* ---------- Auswahl ---------- */

    function waehleTag(datum) {
      var tag = nachTag[datum];
      if (!tag) return;

      gewaehlterTag = datum;
      gewaehlt = null;

      var m = datum.slice(0, 7);
      var i = monate.indexOf(m);
      if (i !== -1 && i !== zeigt) zeigt = i;
      zeichne();

      elZeitkopf.textContent = tag.lesbar;
      elZeiten.innerHTML = '';

      tag.fenster.forEach(function (f) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'fp-tm__zeit';
        b.setAttribute('aria-pressed', 'false');
        b.textContent = f.beginn + (text.uhr ? ' ' + text.uhr : '');
        b.addEventListener('click', function () { waehleZeit(f, b); });
        elZeiten.appendChild(b);
      });

      zeige(elS3, false);
      zeige(elFehler, false);
    }

    function waehleZeit(fenster, knopf) {
      gewaehlt = fenster;
      Array.prototype.forEach.call(elZeiten.children, function (k) {
        k.setAttribute('aria-pressed', String(k === knopf));
      });
      if (elSchnell) {
        Array.prototype.forEach.call(elSchnell.children, function (k) {
          k.setAttribute('aria-pressed', String(k.dataset.fenster === fenster.id));
        });
      }
      zeige(elFehler, false);
      zeige(elS3, true);
    }

    /* ---------- Schnellwahl (Anzeigenversion) ----------
     *
     * Wer von einer Anzeige kommt, soll nicht erst ein Monatsraster
     * lesen. Die ersten drei freien Zeiten stehen als Knoepfe da, ein
     * Tipp waehlt Tag und Zeit, darunter erscheint sofort das
     * Formular. Der Kalender bleibt fuer alle, die einen anderen Tag
     * brauchen, hinter einem zweiten Knopf.
     */
    function schnellwahl(tage) {
      if (!elSchnell) return;

      // Je Tag ein Fenster, abwechselnd das fruehe und das spaete. Vorher
      // war es immer das erste, die Schnellwahl zeigte also nur 17 Uhr.
      var ausgewaehlt = [];
      tage.forEach(function (t) {
        if (ausgewaehlt.length < 3 && t.fenster.length) {
          ausgewaehlt.push({ tag: t, fenster: t.fenster[ausgewaehlt.length % t.fenster.length] });
        }
      });
      // Gibt es weniger als drei Tage, mit weiteren Zeiten auffuellen.
      for (var i = 0; ausgewaehlt.length < 3 && tage[0] && i < tage[0].fenster.length; i++) {
        var weiter = tage[0].fenster[i];
        if (!ausgewaehlt.some(function (a) { return a.fenster.id === weiter.id; })) {
          ausgewaehlt.push({ tag: tage[0], fenster: weiter });
        }
      }

      elSchnell.innerHTML = '';
      ausgewaehlt.forEach(function (a) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'fp-tm__nah';
        b.setAttribute('aria-pressed', 'false');
        b.dataset.fenster = a.fenster.id;
        b.textContent = a.tag.lesbar + ' · ' + a.fenster.beginn + (text.uhr ? ' ' + text.uhr : '');
        b.addEventListener('click', function () {
          waehleTag(a.tag.tag);
          var zeitKnopf = Array.prototype.filter.call(elZeiten.children, function (k) {
            return k.textContent.indexOf(a.fenster.beginn) === 0;
          })[0];
          waehleZeit(a.fenster, zeitKnopf);
          if (elS3.scrollIntoView) {
            elS3.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          }
        });
        elSchnell.appendChild(b);
      });

      if (elMehr) {
        elMehr.addEventListener('click', function () {
          var offen = wurzel.classList.toggle('fp-tm--offen');
          elMehr.setAttribute('aria-expanded', String(offen));
        });
      }
    }

    /* ---------- Buchen ---------- */

    elSenden.addEventListener('click', function () {
      zeige(elFehler, false);

      var name = $('.fp-tm__name').value.trim();
      var mail = $('.fp-tm__mail').value.trim();

      if (!gewaehlt) { fehler(text.ohneZeit || ''); return; }
      if (name.length < 2) { fehler(text.ohneName || ''); return; }
      if (!/^[^@\s]+@[^@\s.]+\.[^@\s]+$/.test(mail)) { fehler(text.ohneMail || ''); return; }

      var beschriftung = elSenden.textContent;
      elSenden.disabled = true;
      elSenden.textContent = text.laeuft || beschriftung;

      fetch(api + '/book', {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify({
          slot: gewaehlt.id,
          name: name,
          email: mail,
          anliegen: $('.fp-tm__anliegen').value.trim(),
          webseite: $('.fp-tm__honig input').value,
          herkunft: herkunft()
        })
      })
        .then(function (r) {
          return r.json().then(function (j) { return { ok: r.ok, daten: j }; });
        })
        .then(function (a) {
          if (!a.ok) {
            // Die Meldung vom Server ist deutsch und fuer Kunden
            // gedacht. Faellt dagegen die Verbindung aus, wirft der
            // Browser etwas Englisches wie "Failed to fetch", und das
            // hat auf der Seite nichts verloren.
            var f = new Error((a.daten && a.daten.fehler) || text.ausfall || '');
            f.vomServer = true;
            throw f;
          }

          $('.fp-tm__wann').textContent =
            a.daten.lesbar + ', ' + a.daten.beginn + (text.uhr ? ' ' + text.uhr : '');

          zeige(elForm, false);
          zeige(elFertig, true);
          metaTermin(a.daten);
          elFertig.setAttribute('tabindex', '-1');
          elFertig.focus({ preventScroll: true });

          // Aus dem hohen Kalender wird eine kurze Bestaetigung. Ohne
          // diesen Sprung steht der Leser danach irgendwo weiter unten
          // auf der Seite und sieht die Bestaetigung gar nicht.
          if (wurzel.scrollIntoView) {
            wurzel.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        })
        .catch(function (e) {
          fehler(e && e.vomServer ? e.message : (text.ausfall || e.message));
          elSenden.disabled = false;
          elSenden.textContent = beschriftung;
        });
    });
  }

  function alle() {
    document.querySelectorAll('[data-fp-api]').forEach(starte);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', alle);
  } else {
    alle();
  }

  // Im Theme-Editor wird der Abschnitt neu gezeichnet.
  document.addEventListener('shopify:section:load', alle);

  // Fuer die Wochentagsleiste im Markup.
  window.fpTermineWochentage = TAGE_KURZ;
})();
